<template>
  <BasicLayout :left="left" :middle="middle" :right="right">
    <template v-slot:left_view>
      <!-- 设置neid -->
      <NeList :neArr="netype" :select="getNe" ref='imsTemplate'></NeList>
    </template>
    <template v-slot:right_view>
      <ToolBar
        :batch="true"
        :delBtn="true"
        :editBtn="true"
        :refreshBtn="true"
        :keywordsInputTemplate="true"
        :dropdownList="true"
        :listDataSource="dataSource"
        @notice="notice"
        @props="props"
        @methodEnum='methodEnum'
      ></ToolBar>
      <div class="h100-80 h-scroll">
        <ejs-grid height='calc(100% - 0px)' :allowPaging="true" ref="grid" :pageSettings="pageSettings" >
          <e-columns>
            <e-column type='checkbox'  width='40' textAlign='Center'></e-column>
            <e-column field='tempnum' :headerText="$t('SubscriberIms.tempnum')" width='110' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
            <e-column field='tempname' :headerText="$t('SubscriberIms.tempname')" width='110' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
            <e-column field='temptypeName' :headerText="$t('SubscriberIms.temptype')" width='180' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
            <e-column field='tempdate' :headerText="$t('SubscriberIms.tempdate')" width='100' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
          </e-columns>
        </ejs-grid>
        <ejs-pager
          ref="pager"
          :pageSize="pageSettings.pageSize"
          :pageCount="pageCount"
          @click="getTemplate(false)"
        ></ejs-pager>
      </div>
      <CustomDialog
        ref="addDialog"
        v-bind:element="addDialog.element"
        v-bind:styles="addDialog.styles"
      >
        <template v-slot:dialog-content>
          <ImsTemplateDialog ref="templateDialog" v-bind:opCode="opCode" v-bind:neid='neid'  :neversion="neversion"></ImsTemplateDialog>
        </template>
      </CustomDialog>
    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from "../../../../layouts/BasicLayout";
import NeList from "../../../../components/subscriberconfig/imsSubscriber/templateManagement/NeList";
import ToolBar from "../../../../components/subscriberconfig/imsSubscriber/ToolBar";
import CustomDialog from "../../../../components/common/CustomDialog";
import ImsTemplateDialog from "../../../../components/subscriberconfig/imsSubscriber/templateManagement/ImsTemplateDialog";

export default {
  name: "ImsTemplateManagement",
  data() {
    return {
      left: {
        show: true,
        name: this.$t('SubscriberIms.neList')
      },
      middle: {
        show: false,
        name: ""
      },
      right: {
        show: true,
        crumb: this.$t('SubscriberIms.temTitle')
      },
      netype: [23],
      dataSource: [
        { text: this.$t('SubscriberIms.all'), value: "0" },
        { text: this.$t('SubscriberIms.user'), value: "1" },
        { text: this.$t('SubscriberIms.group'), value: "2" }
      ],
      toolBarProps: {},
      pageSettings: { pageNo: 1,pageSize: 25 },
      pageCount: 4,
      addDialog: {
        element: {
          target: "#app",
          isClose: true,
          refName: "addTemplate",
          buttonGroup: [
            {
              click: this.dialogHide,
              buttonModel: { content: `${this.$t("System.cancel")}` }
            },
            {
              click: this.confirmAdd,
              buttonModel: { content: `${this.$t("System.confirm")}`,isPrimary: true },
            }
          ],
          title: this.$t('SubscriberIms.add')
        },
        styles: {
          width: "810px",
          height: "auto",
          model: true,
          visible: false
        }
      },
      opCode: "",
      neid: 0,
      neversion: "",
      uOg: 0 // 0-user 1-group
    };
  },
  methods: {
    getNe() {
      this.neid = this.$refs.imsTemplate.getOnlineNe().data.id;
      this.neversion = this.$refs.imsTemplate.getOnlineNe().data.neversion;
      this.getTemplate();
    },
    notice(btn) {
      if (this.neid == 0){
        this.$parent.showToast('warning',`${this.$t('PDN.pleaseSelectNE')}`);
        return null;
      }
      if (btn === "del") {
        this.delFunc();
      }
      if (btn === "edit") {
        this.editFunc();
      }
      if (btn === "refresh") {
        this.refreshFunc();
      }
    },
    props(data) {
      this.toolBarProps = data;
      this.getTemplate();
    },
    delFunc() {
      const record = this.getRecord();
      if (record == null) {
        return null;
      }
      if(record) {
        this.$layer.confirm({
          title: this.$t('SubscriberIms.reminder'),
          msg: this.$t('SubscriberIms.deleteConfirm'),
          btn2: {
            msg: this.$t('SubscriberIms.confirm'),
            func: () => {
              const url = "/lte/ems/subscriber/imsunms/requestCommon";
              const logParam = {
                module: 'res.subscriber#res.subscriber_ims#res.subscriber_ims_template',
                execFunName: 'subscriber.delTemplate',
                exectype: 3,
                execData: []
              };
              const params = {
                vo: {
                  0: record
                },
                info: { msgid: '', neid: this.neid, operation: "delTemplate" },
                log: logParam
              };
              this.axios.post(url, params).then(response => {
                if (response.data.errorCode == '0') {
                  this.$parent.showToast('success', response.data.errorString);
                } else {
                  this.$parent.showToast('error', response.data.errorString);
                }
                this.getTemplate();
              });
            }
          },
          btn1: {
            msg: this.$t('SubscriberIms.cancel')
          }
        });
      }
    },
    editFunc() {
      const record = this.getRecord();
      if (record === null) {
        return null;
      }
      if (record.length != 1) {
        this.$parent.showToast('warning',`${this.$t('SubscriberIms.checkDataMoreTip')}`);
        return null;
      }
      this.opCode = "mod";
      this.addDialog.element.title = this.$t('SubscriberIms.mod');
      // 处理回填数据
      const data = Object.assign(record[0], JSON.parse(record[0]['context']));
      let temptype = 0;
      if (data.temptype == 2) {
        temptype = 1;
      }
      this.$refs.templateDialog.init(temptype);
      this.$refs.templateDialog.mainHandler(data);
      this.$refs.addDialog.show();
    },
    refreshFunc() {
      this.getTemplate();
    },
    getTemplate(isFirstPage = true) {
      const pageNo = isFirstPage ? 1 : this.$refs.pager.ej2Instances.currentPage;
      const url = "/lte/ems/subscriber/imsunms/requestCommon";
      const params = {
        vo: {
          0: { pageNo: pageNo, pageSize: this.pageSettings.pageSize },
          1: { neid: this.neid, temptype: this.dataSource[this.toolBarProps.listIndex].value,
            tempname: this.toolBarProps.keywordTemplate }
        },
        info: { msgid: '', neid: this.neid, operation: "qryTemplate" },
        page: { pageNo: pageNo, pageSize: this.pageSettings.pageSize }
      };
      this.axios.post(url, params).then(response => {
        const data = JSON.parse(response.data.resultVal);
        let showRe = data.result;
        showRe.forEach(item => {
          if (item.temptype == 1) {
            item.temptypeName = this.$t('SubscriberIms.clusterUserCreate');
          } else {
            item.temptypeName = this.$t('SubscriberIms.clusterGroupCreate');;
          }
        });
        this.$refs.grid.ej2Instances.dataSource = showRe;
        this.$refs.pager.ej2Instances.currentPage = pageNo;
        this.$refs.pager.ej2Instances.totalRecordsCount =
          data.totalCount;
        this.$refs.grid.clearSelection();
        setTimeout(()=> {
          if (data.totalCount === 0) { // 没有数据---组件会将domtokenlist增加e-checkbox-disabled属性
            console.log(this.$refs.grid.$el.childNodes[2].children[0].children[0].children[1].children[0].children[0].children[0]);
            const temp = this.$refs.grid.$el.childNodes[2].children[0].children[0].children[1].children[0].children[0].children[0].children[0].classList;
            if (temp.length > 2) {
              temp.remove('e-checkbox-disabled');
            }
          }
        }, 100);
      });
    },
    dialogHide() {
      this.$refs.addDialog.clear();
      this.$refs.addDialog.close();
    },
    confirmAdd() {
      const url = "/lte/ems/subscriber/imsunms/requestCommon";
      const vo = this.$refs.templateDialog.getDatas();
      if (vo == null) {
        return null;
      }
      this.$refs.addDialog.clear();
      this.$refs.addDialog.close();
      const date = new Date().Format('yyyy-MM-dd HH:mm:ss');
      vo['tempdate'] = date;
      let operation = '';
      if (this.opCode === "add") {
        operation = 'addTemplate';
      } else {
        operation = 'modTemplate';
      }
      const logParam = {
        module: 'res.subscriber#res.subscriber_ims#res.subscriber_ims_template',
        execFunName: this.opCode === "add"? 'subscriber.addTemplate':'subscriber.modTemplate',
        exectype: this.opCode === "add" ? 1 : 2,
        execData: []
      };
      const params = {
        vo: {
          0: vo
        },
        info: { msgid: '', neid: this.neid, operation: operation },
        log: logParam
      };
      this.axios.post(url, params).then(response => {
        if (response.data.errorCode == '0') {
          this.$parent.showToast('success', response.data.errorString);
        } else {
          this.$parent.showToast('error', response.data.errorString);
        }
        this.getTemplate();
      });
    },
    getRecord() {
      const record = this.$refs.grid.ej2Instances.getSelectedRecords();
      if (record == null || record == "") {
        this.$parent.showToast('warning',`${this.$t('System.selectOneMessage')}`);
        return null;
      }
      return record;
    },
    methodEnum(args){
      if (this.neid == 0){
        this.$parent.showToast('warning',`${this.$t('PDN.pleaseSelectNE')}`);
        return null;
      }
      this.opCode = "add";
      this.uOg = args;
      this.addDialog.element.title = this.$t('SubscriberIms.add');
      this.$refs.templateDialog.init(this.uOg);
      this.$refs.templateDialog.mainHandler({ neid: this.neid });
      this.$refs.addDialog.show();
    }
  },
  components: {
    BasicLayout,
    NeList,
    ToolBar,
    CustomDialog,
    ImsTemplateDialog
  }
};
</script>
